<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editData" ref="editDataRef" label-width="110px">
          <el-form-item label="主题" class="addAdminForm">
            <el-input v-model="editData.topic" placeholder="请输入主题"></el-input>
          </el-form-item>
          <el-form-item label="副主题" class="addAdminForm">
            <el-input v-model="editData.topicsub" placeholder="请输入副主题"></el-input>
          </el-form-item>
          <el-form-item label="内容" class="addAdminForm">
            <el-input v-model="editData.content" type="textarea" :rows="5" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="是否热点">
            <el-select v-model="editData.ishot" placeholder="请选择" class="select">
              <el-option
                v-for="item in isList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否最新">
            <el-select v-model="editData.isnew" placeholder="请选择" class="select">
              <el-option
                v-for="item in isList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      isList: [
        { value: '1', label: '是' },
        { value: '0', label: '否' }
      ],
      editData: {
        id: '0',
        topic: '',
        topicsub: '',
        content: '',
        ishot: '',
        isnew: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.editData.id = row.Id
      this.editData.topic = row.Topic
      this.editData.topicsub = row.Topicsub
      this.editData.content = row.Content
      this.editData.ishot = row.Ishot.toString()
      this.editData.isnew = row.Isnew.toString()
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.EditKgjtWebsiteAnnouncement()
    },
    EditKgjtWebsiteAnnouncement: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editData.id,
        topic: that.editData.topic,
        topicsub: that.editData.topicsub,
        content: that.editData.content,
        ishot: that.editData.ishot,
        isnew: that.editData.isnew
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditKgjtWebsiteAnnouncement, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
